import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    currentUser: null,
    drawer: null
  },
  getters: {
    isLog (state) {
      return state.currentUser !== null
    },
    isSuperAdmin (state, getters) {
      return getters.isLog && state.currentUser.profil === 'superadmin'
    }
  },
  mutations: {
    setDrawer (state, drawer) {
      state.drawer = drawer
    },
    setToken (state, token) {
      state.token = token
    },
    setCurrentUser (state, user) {
      state.currentUser = user
    },
    logout (state) {
      state.token = null
      state.currentUser = null
    }
  },
  actions: {},
  modules: {}
})
